import classNames from 'classnames';
import { ButtonSize, ButtonTheme, ButtonView } from 'lego-on-react';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { ButtonDecorator } from '../ButtonDecorator/ButtonDecorator';
import { Shape2, Shape2Icon } from '../Shape2/Shape2';

import './AddButtonDecorator.css';

export interface AddButtonDecoratorProps {
    cls?: string;
    onAddClick: () => void;
    value: string;
    disabled?: boolean;
    theme?: ButtonTheme;
    size?: ButtonSize;
    shapeSize?: number;
    view?: ButtonView;
}

const mapSizeToIconSize = (size: ButtonSize): number => {
    switch (size) {
        case 's':
            return 11;
        case 'n':
            return 16;
        default:
            return 11;
    }
};

const BLOCK = 'add-button';

export const AddButtonDecorator = React.memo(
    ({
        cls,
        value,
        onAddClick,
        disabled,
        shapeSize,
        theme = 'pseudo',
        size = 's',
        view = 'classic'
    }: AddButtonDecoratorProps) => {
        const iconSize = shapeSize || mapSizeToIconSize(size);
        return (
            <ButtonDecorator
                cls={classNames(BLOCK, cls)}
                size={size}
                theme={theme}
                disabled={disabled}
                view={view}
                onClick={onAddClick}
            >
                <Shape2 cls={Bem.cls(BLOCK, 'icon')} height={iconSize} width={iconSize} icon={Shape2Icon.plus} />

                {value}
            </ButtonDecorator>
        );
    }
);
